class AtheneumGlobalLookup {
    constructor(form, $formElement, $modal, callback, options) {
        this.form = form;
        this.$formElement = $formElement;
        this.$modal = $modal;
        this.Atheneum = window.AtheneumInstance;
       
        this.defaultOptions = {
            trackTiming: true,
            showCustomNotifications : true,
            iframe: false
        }

        this.callback = callback;
        
        this.options = { ...this.defaultOptions, ...options};
        this.uid = this.uuidv4();
        if(this.$formElement)
            this.$formElement.attr('data-global-lookup-id', this.uid);
        
         this.contacts = [];
        window[this.uid] = this;

        this.currentFilteredContactFilters = null;
        this.currentContactFilters = null;
        this.apiCallInProgress = false;

    }

    uuidv4() {
        return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
            (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
        );
    }

      async shouldPerformLookupForField($element) {
        if(!this.Atheneum.Theme.getBooleanProperty('useContactFilterModal', true)){
            return false;
        }

        if(typeof window.populatingFromSuggestion !== 'undefined' && window.populatingFromSuggestion === true){
            window.populatingFromSuggestion = false;
            return;
        }

        if (typeof hideAllSuggestionLists === "function")
            hideAllSuggestionLists();
        
        $element = $($element);
    
        let fieldName = $element.attr('name'); 
        let fieldsToReactTo = this.Atheneum.Theme.getStringProperty('contactFilterModalManualFields', 'firstName,lastName').split(',');
        
        if(fieldsToReactTo.indexOf(fieldName) < 0){
           return false;
        }
    
        let emailField = this.$formElement.find("input[data-type='EMAIL']").eq(0);
        if(emailField.length > 0 && emailField.val().length > 0){
            return false;
        }
    
        let i;
        let $form = this.$formElement;
        let fieldSearch = {};
    
        // First, check if all fields to react to have values.
        for (i = 0; i < fieldsToReactTo.length; i++) {
            let fieldNameToFind = fieldsToReactTo[i];
            
            let $field = $form.find(
                'input[name="' + fieldNameToFind + '"]' +
                ', select[name="' + fieldNameToFind + '"]' +
                ', textarea[name="' + fieldNameToFind + '"]'
            );
    
            if ($field.length != 0) {
                $field = $($field[0]);
                if ($field.val() == '') {
                    console.log('All items need filling before filter opens');
                    return false;
                } else {
                    // Use the original field name for the criteria object
                    fieldSearch[fieldNameToFind] = $field.val();
                }
            } else {
                console.log('setup likely wrong for contact filtering modal through manual entry');
                return false;
            }
        }
    
          // This function shows the "Searching" modal and triggers the 'shown.bs.modal' event once the modal is visible.
        this.setupContactFilterModalForInternalSearching();
        if(this.$modal)
            this.$modal.modal('show');
        // Use Bootstrap's modal events to ensure the UI updates before the search runs.
        // The '.one()' method ensures this event handler only fires once.
        setTimeout(async () => {
            let contacts;
            if (this.Atheneum.Contacts.contactHelper) {
                contacts = await this.Atheneum.Contacts.contactHelper.getContactsByMultipleCriteria(fieldSearch);
            } else {
                // Fallback logic if contactHelper is not available
                contacts = this.contacts;
                if( this.contacts.length == 0){
                     this.contacts  = await SalesToolkit.Contacts.getById('', { exact: false });
                     contacts = this.contacts;
                }
                // Manually filter if not using the helper
                for(const field in fieldSearch) {
                    if(fieldSearch.hasOwnProperty(field)) {
                        const searchValue = fieldSearch[field].normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
                        contacts = contacts.filter(x => x.info.hasOwnProperty(field) && x.info[field]?.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase() == searchValue);
                    }
                }
            }

            let TRUE_VALUES = ['on', 'true', 'y', 'yes', true]
            if (Array.isArray(contacts) && !TRUE_VALUES.includes(this.Atheneum.User.test)) {
                contacts = contacts.filter(x => !x.hasOwnProperty('test') || !x.test)
            }
        
            if(this.Atheneum.Theme.getBooleanProperty('useGSKContacts', false)){
                let fieldsList = this.Atheneum.Contacts.getCustomFieldListForForm(form);
    
                this.setupContactFilterModalForSearching();
                if(this.$modal)
                    this.$modal.modal('show');
    
                window.start = window.performance.now();
                let glThis = this;
                glThis.apiCallInProgress = true;
                glThis.Atheneum.API.searchGSKContacts(fieldsList, fieldSearch, {
                    success: async function(json){
                       
                        console.log(json);
                        if(json.hasOwnProperty('accounts')){
                           for(const account of json.accounts){
                                let contactIndex = contacts.findIndex(x=> x.info.mdmId === account.mdmId);
                                let dbContact = undefined;
                                if(contactIndex  < 0 && glThis.Atheneum.Contacts.contactHelper){
                                    dbContact = await  glThis.Atheneum.Contacts.contactHelper.getByFieldValue('externalId', account.mdmId, { exact: true});
                                }
                                let contact = dbContact? dbContact : contactIndex < 0? new Atheneum.Contact({}) : contacts[contactIndex];
                                for (let key in account) {
                                    if (account.hasOwnProperty(key) && typeof account[key] !== 'undefined') {
                                        contact.info[key] = account[key];
                                    }
                                }
        
                               
                                if(contactIndex < 0)
                                   contacts.push(contact);
                                else
                                   contacts[contactIndex] = contact;
                            }
                        }
        
                    if(contacts.length === 0)  
                       {
                        let title = glThis.Atheneum.Translation.getOrGetThemeKey('searchingExternalContactsNoMatches', 'Search Complete');
                        let message = glThis.Atheneum.Translation.getOrGetThemeKey('searchingExternalContactsMessage', 'No matching contacts found');
                    
                        if(glThis.options.showCustomNotifications)
                            glThis.Atheneum.UI.Notifications.showCustomNotification("info", message, title);
    
                        if(typeof glThis.callback === 'function'){
                            glThis.callback({ status:"setupForNoContacts", title: title, message: message});
                        }
    
                        if(glThis.$modal){
                            glThis.$modal.find('#contactFilterOptions').empty();
                            glThis.$modal.modal('hide');
                            $('body').removeClass('modal-open');
                            $('.modal-backdrop').remove();
                        }
    
                        glThis.apiCallInProgress = false;
                        return;
                       }
        
                        let atheneumContactOnly = contacts.filter(x => x instanceof Atheneum.Contact);
                        if (atheneumContactOnly.length > 0)
                            contacts = atheneumContactOnly;
        
                        glThis.currentContactFilters = contacts;
        
                        let step = 0;
                        if(contacts.length > 5 && contacts.length < 10)
                            step = 1;
                        else if(contacts.length <= 5)
                            step = 2;
                        
                        if(typeof glThis.callback === 'function'){
                            glThis.callback({ status:"setupForContacts", contacts: contacts, step: step, title: '', message: ''});
                        }
                        
                        glThis.apiCallInProgress = false;
                        glThis.setupContactFilterModalForContacts(contacts, step);
                    },
                    failure: function(reason, httpStatus, errorCode){
        
                        glThis.apiCallInProgress = false;
                            if(contacts.length === 0){
                                if(glThis.$modal){
                                    glThis.$modal.modal('hide');
                                    $('body').removeClass('modal-open');
                                    $('.modal-backdrop').remove();
                                }
                                let type = "info";
                                let errorCodeHex;
                                if (typeof errorCode == 'number') {
                                    errorCodeHex = errorCode.toString(16);
                                    while (errorCodeHex.length < 8) {
                                        errorCodeHex = '0' + errorCodeHex;
                                    }
                                }
                                let message = glThis.Atheneum.Translation.getOrGetThemeKey('error' + errorCodeHex, glThis.Atheneum.Translation.get('notificationContactSearchFailure', 'Could not get contacts informataion'));
                                if (glThis.Atheneum.Theme.getBooleanProperty("includeErrorCodeForContactSearch", true)) {
                                    message += " - " + errorCode;
                                }
        
                                let title = glThis.Atheneum.Translation.get('errorTitle', "Error!");
        
                                if(glThis.options.showCustomNotifications)
                                    glThis.Atheneum.UI.Notifications.showCustomNotification(type, message, title);
    
                                if(typeof glThis.callback === 'function'){
                                    glThis.callback({ status:"setupForNoContacts", title: title, message: message});
                                }
                            }else{
                                let atheneumContactOnly = contacts.filter(x => x instanceof Atheneum.Contact);
                                if (atheneumContactOnly.length > 0)
                                    contacts = atheneumContactOnly;
        
                                glThis.currentContactFilters = contacts;
                
                                let step = 0;
                                if(contacts.length > 5 && contacts.length < 10)
                                    step = 1;
                                else if(contacts.length <= 5)
                                    step = 2;
                                
                                if(typeof glThis.callback === 'function'){
                                    glThis.callback({ status:"setupForContacts", contacts: contacts, step: step, title: '', message: ''});
                                }
                               
                                glThis.setupContactFilterModalForContacts(contacts, step);
                            }
                        
                    }
                });
                return; // End execution here as we are handling externally
            }
    
            if(this.Atheneum.Theme.getBooleanProperty('useVeevaContacts', false)){
                let fieldsList = this.Atheneum.Contacts.getCustomFieldListForForm(this.form);
                this.setupContactFilterModalForSearching();
                if(this.$modal)
                    this.$modal.modal('show');
    
                window.start = window.performance.now();
                let glThis = this;
                glThis.apiCallInProgress = true;
                glThis.Atheneum.API.searchVeevaContacts(fieldsList, fieldSearch, {
                    success: async function(json){
                        if(json.hasOwnProperty('accounts')){
                           for(const account of json.accounts){
                                let contactIndex = contacts.findIndex(x=> x.info.crmId === account.crmId);
                                 let dbContact = undefined;
                                if(contactIndex  < 0 && glThis.Atheneum.Contacts.contactHelper){
                                    dbContact = await  glThis.Atheneum.Contacts.contactHelper.getByFieldValue('externalId', account.crmId, { exact: true});
                                }
                                let contact = dbContact? dbContact : contactIndex < 0? new Atheneum.Contact({}) : contacts[contactIndex];
                              
                                for (let key in account) {
                                    if (account.hasOwnProperty(key) && typeof account[key] !== 'undefined') {
                                        contact.info[key] = account[key];
                                    }
                                }
    
                                if(contactIndex < 0)
                                    contacts.push(contact);
                                else
                                    contacts[contactIndex] = contact;
                            }
                        }
    
                        if(contacts.length === 0)  
                            {
                             let title = glThis.Atheneum.Translation.getOrGetThemeKey('searchingExternalContactsNoMatches', 'Search Complete');
                             let message = glThis.Atheneum.Translation.getOrGetThemeKey('searchingExternalContactsMessage', 'No matching contacts found');
                         
                             if(glThis.options.showCustomNotifications)
                                 glThis.Atheneum.UI.Notifications.showCustomNotification("info", message, title);
         
                             if(typeof glThis.callback === 'function'){
                                 glThis.callback({ status:"setupForNoContacts", title: title, message: message});
                             }
    
                             if(glThis.$modal){
                                glThis.$modal.find('#contactFilterOptions').empty();
                                glThis.$modal.modal('hide');
                                $('body').removeClass('modal-open');
                                $('.modal-backdrop').remove();
                            }
    
                            glThis.apiCallInProgress = false;
                             return;
                            }
             
                             let atheneumContactOnly = contacts.filter(x => x instanceof Atheneum.Contact);
                             if (atheneumContactOnly.length > 0)
                                 contacts = atheneumContactOnly;
             
                             glThis.currentContactFilters = contacts;
             
                             let step = 0;
                             if(contacts.length > 5 && contacts.length < 10)
                                 step = 1;
                             else if(contacts.length <= 5)
                                 step = 2;
                             
                             if(typeof glThis.callback === 'function'){
                                 glThis.callback({ status:"setupForContacts", contacts: contacts, step: step, title: '', message: ''});
                             }
                             
                             glThis.apiCallInProgress = false;
                             glThis.setupContactFilterModalForContacts(contacts, step);
                    },
                    failure: function(reason, httpStatus, errorCode){
                        glThis.apiCallInProgress = false;
                        if(contacts.length === 0){
                            if(glThis.$modal){
                                glThis.$modal.modal('hide');
                                $('body').removeClass('modal-open');
                                $('.modal-backdrop').remove();
                            }
                            let type = "info";
                            let errorCodeHex;
                            if (typeof errorCode == 'number') {
                                errorCodeHex = errorCode.toString(16);
                                while (errorCodeHex.length < 8) {
                                    errorCodeHex = '0' + errorCodeHex;
                                }
                            }
                            let message = glThis.Atheneum.Translation.getOrGetThemeKey('error' + errorCodeHex, glThis.Atheneum.Translation.get('notificationContactSearchFailure', 'Could not get contacts informataion'));
                            if (glThis.Atheneum.Theme.getBooleanProperty("includeErrorCodeForContactSearch", true)) {
                                message += " - " + errorCode;
                            }
    
                            let title = glThis.Atheneum.Translation.get('errorTitle', "Error!");
    
                            if(glThis.options.showCustomNotifications)
                                glThis.Atheneum.UI.Notifications.showCustomNotification(type, message, title);
    
                            if(typeof glThis.callback === 'function'){
                                glThis.callback({ status:"setupForNoContacts", title: title, message: message});
                            }
                        }else{
                            let atheneumContactOnly = contacts.filter(x => x instanceof Atheneum.Contact);
                            if (atheneumContactOnly.length > 0)
                                contacts = atheneumContactOnly;
    
                            glThis.currentContactFilters = contacts;
            
                            let step = 0;
                            if(contacts.length > 5 && contacts.length < 10)
                                step = 1;
                            else if(contacts.length <= 5)
                                step = 2;
                            
                            if(typeof glThis.callback === 'function'){
                                glThis.callback({ status:"setupForContacts", contacts: contacts, step: step, title: '', message: ''});
                            }
                           
                            glThis.setupContactFilterModalForContacts(contacts, step);
                        }
                    }
                });
                return; // End execution here as we are handling externally
        }
            
            if(contacts.length == 0)
            {
                let title = this.Atheneum.Translation.getOrGetThemeKey('searchingLocalContacts', 'Search Complete');
                let message = this.Atheneum.Translation.getOrGetThemeKey('searchingLocalContactsMessage', 'No matching contacts found');
            
                if(this.options.showCustomNotifications)
                    this.Atheneum.UI.Notifications.showCustomNotification("info", message, title);
    
                if(typeof this.callback === 'function'){
                    this.callback({ status:"setupForNoContacts", title: title, message: message});
                }
                // Hide the "searching" modal if no contacts are found
                if(this.$modal) this.$modal.modal('hide');
                return;
            }
        
            let atheneumContactOnly = contacts.filter(x => x instanceof Atheneum.Contact);
            if (atheneumContactOnly.length > 0)
                contacts = atheneumContactOnly;
        
            this.currentContactFilters = contacts;
            
            let step = 0;
            if(contacts.length > 5 && contacts.length < 10)
                step = 1;
            else if(contacts.length <= 5)
                step = 2;
            
            if(typeof this.callback === 'function'){
                this.callback({ status:"setupForContacts", contacts: contacts, step: step, title: '', message: ''});
            }
    
            this.setupContactFilterModalForContacts(contacts, step);

        }, 0);
     
        return true;
    }


    async performLookupFromScanResults(result) {
         //Otherwise try to find a contact matching the info  
         let firstName = result.firstName;
         let lastName = result.lastName;
         let emails = result.emails;
         let phones = result.phones;
         let company = '';
         try{
             company = result.jobs[0].company;
         }catch(err){
             console.log(err);
             company = '';
         }

          let contacts = this.contacts;
        
         if(this.Atheneum.Contacts.contactHelper){
            try {
                 // Initialize an empty object for the search criteria
                const searchCriteria = {};

                // Conditionally add criteria if they are defined and have content
                if (firstName && typeof firstName === 'string' && firstName.trim() !== '') {
                    searchCriteria.firstName = firstName;
                }
                if (lastName && typeof lastName === 'string' && lastName.trim() !== '') {
                    searchCriteria.lastName = lastName;
                }
                if (emails && Array.isArray(emails) && emails.length > 0) {
                    searchCriteria.emails = emails;
                }
                if (phones && Array.isArray(phones) && phones.length > 0) {
                    searchCriteria.phones = phones;
                }
                if (company && typeof company === 'string' && company.trim() !== '') {
                    searchCriteria.company = company;
                }
                // Call the new method to retrieve contacts based on multiple criteria
                contacts = await this.Atheneum.Contacts.contactHelper.getContactsByMultipleCriteria(searchCriteria);

                // Now, 'contacts' will contain an array of unique Atheneum.Contact objects
                // that matched any of the provided criteria.
                // You can proceed with processing 'contacts' here.

            } catch (error) {
                console.error("Error retrieving contacts:", error);
                // Handle the error appropriately, e.g., show a message to the user
                contacts = this.contacts; // Ensure contacts is an empty array on error
            }
        }else if( this.contacts.length == 0){
             this.contacts  = await SalesToolkit.Contacts.getById('', { exact: false });
             contacts = this.contacts;
        }
         let TRUE_VALUES = ['on', 'true', 'y', 'yes', true]
         if (Array.isArray(contacts) && !TRUE_VALUES.contains(this.Atheneum.User.test)) {
             contacts = contacts.filter(x => !x.hasOwnProperty('test') || !x.test)
         }

         let minimumSimilarity = this.Atheneum.Theme.getFloatProperty('minimumSimilarity', 1);
         let contact = contacts.filter(x => anySimilarEmails(emails, x.info?.email) || anyMatchingPhones(phones, (x.info?.phone || x.info?.phoneNumber || x.info.phoneNo)));
         
         if(!contact || contact.length == 0){
             let companyFieldName = this.Atheneum.Theme.getStringProperty('companyContactFieldName', 'company');
             contact = contacts.filter(x => x.hasOwnProperty('info') && x.info.hasOwnProperty(companyFieldName) && similarity(x.info[companyFieldName], company) >= minimumSimilarity);
         }else if(contact.length > 1){
             let companyFieldName = this.Atheneum.Theme.getStringProperty('companyContactFieldName', 'company');
             contact = contact.filter(x => x.hasOwnProperty('info') && x.info.hasOwnProperty(companyFieldName) && similarity(x.info[companyFieldName], company) >= minimumSimilarity);
         }

         if(!contact || contact.length == 0){
             contact = contacts.filter(x => similarity(x.info?.firstName, firstName) >= minimumSimilarity && similarity(x.info?.lastName, lastName) >= minimumSimilarity);
         }else if(contact.length > 1){
             contact = contact.filter(x => similarity(x.info?.firstName, firstName) >= minimumSimilarity && similarity(x.info?.lastName, lastName) >= minimumSimilarity);
          }

          contacts = contact;

          let glThis = this;
          
          if(this.Atheneum.Theme.getBooleanProperty('useGSKContacts', false)){
   
             getFormData(this.$formElement, function(formData){
             if(firstName)
                 formData[glThis.Atheneum.Theme.getStringProperty('customFieldNameConversion_firstName', "firstName")] = firstName.toLowerCase();
             if(lastName)
                 formData[glThis.Atheneum.Theme.getStringProperty('customFieldNameConversion_lastName', "lastName")] = lastName.toLowerCase();
             if(emails && emails.length > 0)
                 formData[glThis.Atheneum.Theme.getStringProperty('customFieldNameConversion_email', "email")] = emails[0].address?.toLowerCase();
             if(phones && phones.length > 0)
                 formData[glThis.Atheneum.Theme.getStringProperty('customFieldNameConversion_phone', "phone")] = phones[0].number?.toLowerCase();
             if(company)
                 formData[glThis.Atheneum.Theme.getStringProperty('customFieldNameConversion_company', "company")] = company.toLowerCase();
             
             let fieldsList = glThis.Atheneum.Contacts.getCustomFieldListForForm(form);
             
             glThis.setupContactFilterModalForSearching();
             if(glThis.$modal)
                glThis.$modal.modal('show');

             window.start = window.performance.now();
             glThis.apiCallInProgress = true;
             glThis.Atheneum.API.searchGSKContacts(fieldsList, formData, {
                 success: async function(json){
                     console.log(json);
                     if(json.hasOwnProperty('accounts')){
                        

                         for(const account of json.accounts){
                             let contactIndex = contacts.findIndex(x=> x.info.mdmId === account.mdmId);
                              let dbContact = undefined;
                                if(contactIndex  < 0 && glThis.Atheneum.Contacts.contactHelper){
                                    dbContact = await  glThis.Atheneum.Contacts.contactHelper.getByFieldValue('externalId', account.mdmId, { exact: true});
                                }
                             let contact = dbContact? dbContact : contactIndex < 0? new Atheneum.Contact({}) : contacts[contactIndex];
                             for (let key in account) {
                                 if (account.hasOwnProperty(key) && typeof account[key] !== 'undefined') {
                                    let keyTranslation = glThis.Atheneum.Theme.getStringProperty('gskKeyTranslation_'+key, key);
                                     contact.info[keyTranslation] = account[key];
                                 }
                             }

                            
                             if(contactIndex < 0)
                                contacts.push(contact);
                             else
                                contacts[contactIndex] = contact;
                         }
                     }

                 if(contacts.length === 0)  
                    {
                        let title = glThis.Atheneum.Translation.getOrGetThemeKey('searchingExternalContactsNoMatches', 'Search Complete');
                        let message = glThis.Atheneum.Translation.getOrGetThemeKey('searchingExternalContactsMessage', 'No matching contacts found');
                    
                        if(glThis.options.showCustomNotifications)
                            glThis.Atheneum.UI.Notifications.showCustomNotification("info", message, title);
    
                        if(typeof glThis.callback === 'function'){
                            glThis.callback({ status:"setupForNoContacts", title: title, message: message, fromScan: true});
                        }

                        if(glThis.$modal){
                            glThis.$modal.find('#contactFilterOptions').empty();
                            glThis.$modal.modal('hide');
                            $('body').removeClass('modal-open');
                            $('.modal-backdrop').remove();
                        }
                        glThis.apiCallInProgress = false;
                        return;
                    }

                     let atheneumContactOnly = contacts.filter(x => x instanceof Atheneum.Contact);
                     if (atheneumContactOnly.length > 0)
                         contacts = atheneumContactOnly;

                     glThis.currentContactFilters = contacts;
     
                     let step = 0;
                     if(contacts.length > 5 && contacts.length < 10)
                         step = 1;
                     else if(contacts.length <= 5)
                         step = 2;
                     
                    if(typeof glThis.callback === 'function'){
                        glThis.callback({ status:"setupForContacts", contacts: contacts, step: step, title: '', message: '', fromScan: true});
                    }
                    glThis.apiCallInProgress = false;
                    glThis.setupContactFilterModalForContacts(contacts, step);
                     
                 },
                 failure: function(reason, httpStatus, errorCode){
                    glThis.apiCallInProgress = false;
                     if(contacts.length === 0)  
                     {
                        if(glThis.$modal){
                            glThis.$modal.modal('hide');
                            $('body').removeClass('modal-open');
                            $('.modal-backdrop').remove();
                        }

                        let type = "info";
                        let errorCodeHex;
                        if (typeof errorCode == 'number') {
                            errorCodeHex = errorCode.toString(16);
                            while (errorCodeHex.length < 8) {
                                errorCodeHex = '0' + errorCodeHex;
                            }
                        }
                        let message = glThis.Atheneum.Translation.getOrGetThemeKey('error' + errorCodeHex, glThis.Atheneum.Translation.get('notificationContactSearchFailure', 'Could not get contacts informataion'));
                        if (glThis.Atheneum.Theme.getBooleanProperty("includeErrorCodeForContactSearch", true)) {
                            message += " - " + errorCode;
                        }

                        let title = glThis.Atheneum.Translation.get('errorTitle', "Error!");

                        if(glThis.options.showCustomNotifications)
                            glThis.Atheneum.UI.Notifications.showCustomNotification(type, message, title);

                        if(typeof glThis.callback === 'function'){
                            glThis.callback({ status:"setupForNoContacts", title: title, message: message, fromScan: true});
                        }
                     }else{
                        
                         let atheneumContactOnly = contacts.filter(x => x instanceof Atheneum.Contact);
                         if (atheneumContactOnly.length > 0)
                             contacts = atheneumContactOnly;
 
                         glThis.currentContactFilters = contacts;
         
                         let step = 0;
                         if(contacts.length > 5 && contacts.length < 10)
                             step = 1;
                         else if(contacts.length <= 5)
                             step = 2;
                         
                        if(typeof glThis.callback === 'function'){
                            glThis.callback({ status:"setupForContacts", contacts: contacts, step: step, title: '', message: '', fromScan: true});
                        }
                        
                        glThis.setupContactFilterModalForContacts(contacts, step);
                     }
                 }
             });
             });
             
             return;
         }

         if(this.Atheneum.Theme.getBooleanProperty('useVeevaContacts', false)){
   
            let glThis = this;
         
             getFormData(this.$formElement, function(formData){
             if(firstName)
                 formData[glThis.Atheneum.Theme.getStringProperty('customFieldNameConversion_firstName', "firstName")] = firstName.toLowerCase();
             if(lastName)
                 formData[glThis.Atheneum.Theme.getStringProperty('customFieldNameConversion_lastName', "lastName")] = lastName.toLowerCase();
             if(emails && emails.length > 0)
                 formData[glThis.Atheneum.Theme.getStringProperty('customFieldNameConversion_email', "email")] = emails[0].address?.toLowerCase();
             if(phones && phones.length > 0)
                 formData[glThis.Atheneum.Theme.getStringProperty('customFieldNameConversion_phone', "phone")] = phones[0].number?.toLowerCase();
             if(company)
                 formData[glThis.Atheneum.Theme.getStringProperty('customFieldNameConversion_company', "company")] = company.toLowerCase();
             
             let fieldsList = glThis.Atheneum.Contacts.getCustomFieldListForForm(form);
             
             glThis.setupContactFilterModalForSearching();
             if(glThis.$modal)
                glThis.$modal.modal('show');

             window.start = window.performance.now();
             glThis.apiCallInProgress = true;
             glThis.Atheneum.API.searchVeevaContacts(fieldsList, formData, {
                 success: async function(json){
                     console.log(json);
                     if(json.hasOwnProperty('accounts')){
                         for(const account of json.accounts){
                             let contactIndex = contacts.findIndex(x=> x.info.crmId === account.crmId);
                             let dbContact = undefined;
                             if(contactIndex  < 0 && glThis.Atheneum.Contacts.contactHelper){
                                dbContact = await  glThis.Atheneum.Contacts.contactHelper.getByFieldValue('externalId', account.crmId, { exact: true});
                             }
                             let contact = dbContact? dbContact : contactIndex < 0? new Atheneum.Contact({}) : contacts[contactIndex];
                             
                             for (let key in account) {
                                 if (account.hasOwnProperty(key) && typeof account[key] !== 'undefined') {
                                    let keyTranslation = glThis.Atheneum.Theme.getStringProperty('veevaKeyTranslation_'+key, key);
                                    contact.info[keyTranslation] = account[key];
                                 }
                             }

                            
                             if(contactIndex < 0)
                                contacts.push(contact);
                             else
                                contacts[contactIndex] = contact;
                         }
                     }

                 if(contacts.length === 0)  
                    {
                        let title = glThis.Atheneum.Translation.getOrGetThemeKey('searchingExternalContactsNoMatches', 'Search Complete');
                        let message = glThis.Atheneum.Translation.getOrGetThemeKey('searchingExternalContactsMessage', 'No matching contacts found');
                    
                        if(glThis.options.showCustomNotifications)
                            glThis.Atheneum.UI.Notifications.showCustomNotification("info", message, title);
    
                        if(typeof glThis.callback === 'function'){
                            glThis.callback({ status:"setupForNoContacts", title: title, message: message, fromScan: true});
                        }

                        if(glThis.$modal){
                            glThis.$modal.find('#contactFilterOptions').empty();
                            glThis.$modal.modal('hide');
                            $('body').removeClass('modal-open');
                            $('.modal-backdrop').remove();
                        }
                        glThis.apiCallInProgress = false;
                        return;
                    }

                     let atheneumContactOnly = contacts.filter(x => x instanceof Atheneum.Contact);
                     if (atheneumContactOnly.length > 0)
                         contacts = atheneumContactOnly;

                     glThis.currentContactFilters = contacts;
     
                     let step = 0;
                     if(contacts.length > 5 && contacts.length < 10)
                         step = 1;
                     else if(contacts.length <= 5)
                         step = 2;
                     
                     if(typeof glThis.callback === 'function'){
                        glThis.callback({ status:"setupForContacts", contacts: contacts, step: step, title: '', message: '', fromScan: true});
                    }
                    glThis.apiCallInProgress = false;
                    glThis.setupContactFilterModalForContacts(contacts, step);
                     
                 },
                 failure: function(reason, httpStatus, errorCode){
                    glThis.apiCallInProgress = false;
                     if(contacts.length === 0)  
                     {
                        if(glThis.$modal){
                            glThis.$modal.modal('hide');
                            $('body').removeClass('modal-open');
                            $('.modal-backdrop').remove();
                        }

                        let type = "info";
                        let errorCodeHex;
                        if (typeof errorCode == 'number') {
                            errorCodeHex = errorCode.toString(16);
                            while (errorCodeHex.length < 8) {
                                errorCodeHex = '0' + errorCodeHex;
                            }
                        }
                        let message = glThis.Atheneum.Translation.getOrGetThemeKey('error' + errorCodeHex, glThis.Atheneum.Translation.get('notificationContactSearchFailure', 'Could not get contacts informataion'));
                        if (glThis.Atheneum.Theme.getBooleanProperty("includeErrorCodeForContactSearch", true)) {
                            message += " - " + errorCode;
                        }

                        let title = glThis.Atheneum.Translation.get('errorTitle', "Error!");

                        if(glThis.options.showCustomNotifications)
                            glThis.Atheneum.UI.Notifications.showCustomNotification(type, message, title);

                        if(typeof glThis.callback === 'function'){
                            glThis.callback({ status:"setupForNoContacts", title: title, message: message, fromScan: true});
                        }
                     }else{
                         let atheneumContactOnly = contacts.filter(x => x instanceof Atheneum.Contact);
                         if (atheneumContactOnly.length > 0)
                             contacts = atheneumContactOnly;
 
                         glThis.currentContactFilters = contacts;
         
                         let step = 0;
                         if(contacts.length > 5 && contacts.length < 10)
                             step = 1;
                         else if(contacts.length <= 5)
                             step = 2;
                         
                        if(typeof glThis.callback === 'function'){
                            glThis.callback({ status:"setupForContacts", contacts: contacts, step: step, title: '', message: '', fromScan: true});
                        }
                        
                        glThis.setupContactFilterModalForContacts(contacts, step);
                     }
                 }
             });
             });
             
             return;
         }

         if(contact.length > 1){
             let atheneumContactOnly = contact.filter(x=> x instanceof Atheneum.Contact);
             if(atheneumContactOnly.length > 0)
                 contact = atheneumContactOnly;
         }
        
         if(contact && contact.length > 1){
                let notificationBody = this.Atheneum.Translation.get('notificationCardReaderMultipleContacts', 'Multiple contacts found, please select from the suggestions');
                 this.Atheneum.UI.Notifications.showCustomNotification("info", notificationBody);

                 if(this.options.showCustomNotifications)
                     this.Atheneum.UI.Notifications.showCustomNotification("info", notificationBody);
     
                 if(typeof this.callback === 'function'){
                    this.callback({ status:"cameraStop", title: '', message: notificationBody, fromScan: true});
                 }

                if (this.Atheneum.Theme.getBooleanProperty('useContactFilterModal', true)) {

                        this.currentContactFilters = contact;

                        // if(this.$modal){
                        //     //CHANGED FOR GLU
                        //     if(this.options.iframe){
                        //         $(this.$modal).modal('show');
                        //         $('.modal-backdrop').hide();  
                        //     } else {
                        //         this.$modal.modal('show');
                        //     }
                        //  }

                        let step = 0;
                        if(contact.length > 5 && contact.length < 10)
                            step = 1;
                        else if(contact.length <= 5)
                            step = 2;
                        
                        if(typeof this.callback === 'function'){
                            this.callback({ status:"setupForContacts", contacts: contact, step: step, title: '', message: '', fromScan: true});
                        }

                        this.setupContactFilterModalForContacts(contact, step);
                        return;
                }
                 

                if(typeof glThis.callback === 'function'){
                    glThis.callback({ status:"suggestions", contacts: contact, step: step, title: '', message: '', fromScan: true});
                }
         }else if (!contact || contact.length == 0) {
            let title = glThis.Atheneum.Translation.getOrGetThemeKey('searchingLocalContacts', 'Search Complete');
            let message = glThis.Atheneum.Translation.getOrGetThemeKey('searchingLocalContactsMessage', 'No matching contacts found');
        
            if(glThis.options.showCustomNotifications)
                glThis.Atheneum.UI.Notifications.showCustomNotification("info", message, title);

            if(typeof glThis.callback === 'function'){
                glThis.callback({ status:"setupForNoContacts", title: title, message: message, fromScan: true});
            }
        } else if(typeof glThis.callback === 'function'){
            if(glThis.$formElement)
                populateFormWithContact(glThis.$formElement, contact[0]);
            
            if(typeof glThis.callback === 'function'){
                glThis.callback({ status:"populateContact", contact: contact[0], fromScan: true });
            }

            if(typeof glThis.callback === 'function'){
                glThis.callback({ status:"cameraStop", fromScan: true });
            }
        }
    }

    setupContactFilterModalForSearching(){

        if(!this.$modal){
            if(typeof this.callback === 'function'){
                this.callback({ status:"searching", contacts: [], title: '', message: ''});
            }
            return;
        }
        $('#externalAPITimer').hide();
        $('#externalAPITimer').empty();
        
        this.$modal.find('#contactFilterOptions').empty();
        this.$modal.find('#contactFilterOptions').append('<span>'+ this.Atheneum.Translation.getOrGetThemeKey('searchingExternalContactsMessage', 'Searching external contacts please wait...')+'</span>')
        this.$modal.find('#restartButton').hide();
    }

    setupContactFilterModalForInternalSearching(){

        if(!this.$modal){
            if(typeof this.callback === 'function'){
                this.callback({ status:"searching", contacts: [], title: '', message: ''});
            }
            return;
        }
        $('#externalAPITimer').hide();
        $('#externalAPITimer').empty();
        
        this.$modal.find('#contactFilterOptions').empty();
        this.$modal.find('#contactFilterOptions').append('<span>'+ this.Atheneum.Translation.getOrGetThemeKey('searchingInternalContactsMessage', 'Searching contacts please wait...')+'</span>')
        this.$modal.find('#restartButton').hide();
    }

    getGSKContactInformation(mdmId){
        let glThis = this;
        return new Promise(function(resolve, reject){

            if(typeof mdmId === 'undefined'){
                resolve({});
                return;
            }

            glThis.Atheneum.API.searchGSKContactDetails(mdmId, {
                success: function(json){
                    console.log(json);
                    resolve(json);
                },
                failure: function(reason, httpStatus, errorCode){
                    let type = "info";
                    let errorCodeHex;
                    if (typeof errorCode == 'number') {
                        errorCodeHex = errorCode.toString(16);
                        while (errorCodeHex.length < 8) {
                            errorCodeHex = '0' + errorCodeHex;
                        }
                    }

                    let message = glThis.Atheneum.Translation.getOrGetThemeKey('error' + errorCodeHex, glThis.Atheneum.Translation.get('notificationContactDetailsSearchFailure', 'Could not get contacts detailed information'));
                    if (glThis.Atheneum.Theme.getBooleanProperty("includeErrorCodeForContactDetailsSearch", true)) {
                        message += " - " + errorCode;
                    }

                    let title = glThis.Atheneum.Translation.get('errorTitle', "Error!");
                    if(glThis.options.showCustomNotifications)
                        glThis.Atheneum.UI.Notifications.showCustomNotification(type, message, title);

                    resolve({});
                }
            });
          
        });
    }

    getVeevaContactInformation(crmId){
        let glThis = this;
        return new Promise(function(resolve, reject){

            if(typeof crmId === 'undefined'){
                resolve({});
                return;
            }

            glThis.Atheneum.API.searchVeevaContactDetails(crmId, {
                success: function(json){
                    console.log(json);
                    resolve(json);
                },
                failure: function(reason, httpStatus, errorCode){
                    let type = "info";
                    let errorCodeHex;
                    if (typeof errorCode == 'number') {
                        errorCodeHex = errorCode.toString(16);
                        while (errorCodeHex.length < 8) {
                            errorCodeHex = '0' + errorCodeHex;
                        }
                    }
                    let message = glThis.Atheneum.Translation.getOrGetThemeKey('error' + errorCodeHex, glThis.Atheneum.Translation.get('notificationContactDetailsSearchFailure', 'Could not get contacts detailed information'));
                    if (glThis.Atheneum.Theme.getBooleanProperty("includeErrorCodeForContactDetailsSearch", true)) {
                        message += " - " + errorCode;
                    }

                    let title = glThis.Atheneum.Translation.get('errorTitle', "Error!");
                    if(glThis.options.showCustomNotifications)
                        glThis.Atheneum.UI.Notifications.showCustomNotification(type, message, title);

                    resolve({});
                }
            });
          
        });
    }

    filterContactModalFilter(property, value, step, undef){
        value = unescape(value);
        if(typeof this.currentFilteredContactFilters !== 'object' || !Array.isArray(this.currentFilteredContactFilters)){
            let notificationBody = this.Atheneum.Translation.get('notificationContactFilterErrorFilters', 'Error: Could not find contact list to filter');
            if(this.options.showCustomNotifications)
                this.Atheneum.UI.Notifications.showCustomNotification("info", notificationBody);
        }

        let contacts = this.currentFilteredContactFilters;
        if(undef){
            contacts = contacts.filter(x=> !x.info.hasOwnProperty(property) || typeof x.info[property] === 'undefined');
        }else{
            contacts = contacts.filter(x=> x.info.hasOwnProperty(property) && x.info[property]?.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase() == value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase());
        }

        //Skip to last step if contacts is 5 or under already
        if(step == 0 && contacts.length <= 5)
            step = 1;
       
        this.setupContactFilterModalForContacts(contacts, (step + 1));
    }

    setupContactFilterModalForContacts(contacts, step, forceInDoubt = false){
       if(contacts.length == 1){

            if(this.Atheneum.Theme.getBooleanProperty('useGSKContacts', false)){
                let contact =  contacts[0];
                let glThis = this;
                glThis.apiCallInProgress = true;
                getGSKContactInformation(contact.info.mdmId).then(json => {
                    if(json.hasOwnProperty('account')){
                           
                        for (let key in json.account) {
                            if (json.account.hasOwnProperty(key) && typeof json.account[key] !== 'undefined') {
                                let keyTranslation = glThis.Atheneum.Theme.getStringProperty('gskKeyTranslation_'+key, key);
                                contact.info[keyTranslation] = json.account[key];
                            }
                        }

                        contacts[0] = contact;
                    }

                   
                    glThis.currentFilteredContactFilters = null;

                    if(typeof glThis.Atheneum.Contacts.customContacts === 'undefined'){
                        glThis.Atheneum.Contacts.customContacts = {};
                    }

                    contacts[0].status = contacts[0].info.status;
                   
                    // if the user answers yes then fill it in, otherwise show a notification saying no matching contact found 
                    let fieldsToCheckLastContact = glThis.Atheneum.Theme.getStringProperty('contactFilterModalLastCheck', 'firstName,lastName').split(',');
                    let matchInDoubt = false;
                    let $form = glThis.$formElement;
                    for(let i = 0; i < fieldsToCheckLastContact.length; i++){
                        let fieldName = fieldsToCheckLastContact[i];
                        
                        let $field = $form.find(
                            'input[name="' + fieldName + '"]'
                            + ', select[name="' + fieldName + '"]'
                            + ', textarea[name="' + fieldName + '"]'
                        );

                        if($field.length != 0){
                            $field = $($field[0]);
                            if($field.val() == ''){
                                matchInDoubt = true;
                                break;
                            }
                            if(!contacts[0].info?.hasOwnProperty(fieldName)){
                                matchInDoubt = true;
                                break;
                            }

                            let fieldValue = $field.val().normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
                            let contactValue = contacts[0].info[fieldName].normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
                            if(contactValue !== fieldValue){
                                matchInDoubt = true;
                                break;
                            }
                        }else{
                            console.log('setup likely wrong for contact filtering modal last match');
                        }
                     }

                     if(!forceInDoubt && matchInDoubt){
                        glThis.setupContactFilterModalForContactsProperty("", 4, contacts, true);
                        glThis.apiCallInProgress = false;
                        return;
                     }
                     glThis.Atheneum.Contacts.customContacts[contacts[0].info.mdmId] =  contacts[0];

                     if(glThis.$formElement)
                        populateFormWithContact(glThis.$formElement, contacts[0]);
                    
                     glThis.apiCallInProgress = false;
                    if(typeof glThis.callback === 'function'){
                        glThis.callback({ status:"populateContact", contact: contacts[0] });
                    }
                     let notificationBody = glThis.Atheneum.Translation.get('notificationContactFilterModalMatch', 'Contact loaded from filters');
                    
                    if(glThis.options.showCustomNotifications)
                        glThis.Atheneum.UI.Notifications.showCustomNotification("info", notificationBody);
                    
                    if(glThis.$modal){
                        glThis.$modal.find('#contactFilterOptions').empty();
                        glThis.$modal.modal('hide');
                        $('body').removeClass('modal-open');
                        $('.modal-backdrop').remove();
                    }

                    if(typeof glThis.callback === 'function'){
                        glThis.callback({ status:"emptyFilterOptions"});
                    }
                    //CHANGED FOR GLU -- MOVED THIS CODE INSIDE THE NEXT IF
                    // let end = window.performance.now();
                    // let dur = end - start;
                    // if(glThis.options.trackTiming && typeof trackTiming === 'function')
                    //     trackTiming(glThis.Atheneum.Translation.get('externalAPITimerTracking', 'externalAPITimerTracking'), dur);
                    
                
                    if(glThis.Atheneum.Theme.getBooleanProperty('useGSKContacts', false) && glThis.Atheneum.Theme.getBooleanProperty('showExternalAPITime', true)){
                        let end = window.performance.now();
                        let dur = end - start;
                        if(glThis.options.trackTiming && typeof trackTiming === 'function')
                        trackTiming(glThis.Atheneum.Translation.get('externalAPITimerTracking', 'externalAPITimerTracking'), dur);

                        dur = dur / 1000;
                        dur = (Math.round(dur * 100) / 100).toFixed(2);
                      
                        let notificationBody = glThis.Atheneum.Translation.getFormatted('externalAPITimedBody', 'Took {0}s to retrieve contact data', [(""+dur)]);
                        let title = glThis.Atheneum.Translation.get('externalAPITimedTitle', 'Ready');
                        if(glThis.options.showCustomNotifications)
                            glThis.Atheneum.UI.Notifications.showCustomNotification("info", notificationBody, title);
                    }
                });
                return;
            }

            if(this.Atheneum.Theme.getBooleanProperty('useVeevaContacts', false)){
                let contact =  contacts[0];
                let glThis = this;
                glThis.apiCallInProgress = true;
                glThis.getVeevaContactInformation(contact.info.crmId).then(json => {
                    if(json.hasOwnProperty('account')){
                           
                        for (let key in json.account) {
                            if (json.account.hasOwnProperty(key) && typeof json.account[key] !== 'undefined') {
                                let keyTranslation = glThis.Atheneum.Theme.getStringProperty('veevaKeyTranslation_'+key, key);
                                contact.info[keyTranslation] = json.account[key];
                            }
                        }

                        contacts[0] = contact;
                    }

                   
                    glThis.currentFilteredContactFilters = null;

                    if(typeof glThis.Atheneum.Contacts.customContacts === 'undefined'){
                        glThis.Atheneum.Contacts.customContacts = {};
                    }

                    contacts[0].status = contacts[0].info.status;
                   
                    // if the user answers yes then fill it in, otherwise show a notification saying no matching contact found 
                    let fieldsToCheckLastContact = glThis.Atheneum.Theme.getStringProperty('contactFilterModalLastCheck', 'firstName,lastName').split(',');
                    let matchInDoubt = false;
                    let $form = glThis.$formElement;
                    for(let i = 0; i < fieldsToCheckLastContact.length; i++){
                        let fieldName = fieldsToCheckLastContact[i];
                        
                        let $field = $form.find(
                            'input[name="' + fieldName + '"]'
                            + ', select[name="' + fieldName + '"]'
                            + ', textarea[name="' + fieldName + '"]'
                        );

                        if($field.length != 0){
                            $field = $($field[0]);
                            if($field.val() == ''){
                                matchInDoubt = true;
                                break;
                            }
                            if(!contacts[0].info?.hasOwnProperty(fieldName)){
                                matchInDoubt = true;
                                break;
                            }

                            let fieldValue = $field.val().normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
                            let contactValue = contacts[0].info[fieldName].normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
                            if(contactValue !== fieldValue){
                                matchInDoubt = true;
                                break;
                            }
                        }else{
                            console.log('setup likely wrong for contact filtering modal last match');
                        }
                     }

                     if(!forceInDoubt && matchInDoubt){
                        glThis.setupContactFilterModalForContactsProperty("", 4, contacts, true);
                        glThis.apiCallInProgress = false;
                        return;
                     }
                     glThis.Atheneum.Contacts.customContacts[contacts[0].info.crmId] =  contacts[0];
                
                     if(glThis.$formElement)
                        populateFormWithContact(glThis.$formElement, contacts[0]);
                    
                     glThis.apiCallInProgress = false;
                    if(typeof glThis.callback === 'function'){
                        glThis.callback({ status:"populateContact", contact: contacts[0] });
                    }
                     let notificationBody = glThis.Atheneum.Translation.get('notificationContactFilterModalMatch', 'Contact loaded from filters');
                    
                    if(glThis.options.showCustomNotifications)
                        glThis.Atheneum.UI.Notifications.showCustomNotification("info", notificationBody);
                    
                    if(glThis.$modal){
                        glThis.$modal.find('#contactFilterOptions').empty();
                        glThis.$modal.modal('hide');
                        $('body').removeClass('modal-open');
                        $('.modal-backdrop').remove();
                    }

                    if(typeof glThis.callback === 'function'){
                        glThis.callback({ status:"emptyFilterOptions"});
                    }
                    //CHANGED FOR GLU -- MOVED THIS CODE INSIDE THE NEXT IF
                    // let end = window.performance.now();
                    // let dur = end - start;
                    // if(glThis.options.trackTiming && typeof trackTiming === 'function')
                    //     trackTiming(glThis.Atheneum.Translation.get('externalAPITimerTracking', 'externalAPITimerTracking'), dur);
                    
                
                    if(glThis.Atheneum.Theme.getBooleanProperty('useVeevaContacts', false) && glThis.Atheneum.Theme.getBooleanProperty('showExternalAPITime', true)){
                        let end = window.performance.now();
                        let dur = end - start;
                        if(glThis.options.trackTiming && typeof trackTiming === 'function')
                        trackTiming(glThis.Atheneum.Translation.get('externalAPITimerTracking', 'externalAPITimerTracking'), dur);

                        dur = dur / 1000;
                        dur = (Math.round(dur * 100) / 100).toFixed(2);
                      
                        let notificationBody = glThis.Atheneum.Translation.getFormatted('externalAPITimedBody', 'Took {0}s to retrieve contact data', [(""+dur)]);
                        let title = glThis.Atheneum.Translation.get('externalAPITimedTitle', 'Ready');
                        if(glThis.options.showCustomNotifications)
                            glThis.Atheneum.UI.Notifications.showCustomNotification("info", notificationBody, title);
                    }
                });
                return;
            }

            this.currentFilteredContactFilters = null;
            
            if(this.$formElement)
                populateFormWithContact(this.$formElement, contacts[0]);
            let glThis = this;
            if(typeof glThis.callback === 'function'){
                glThis.callback({ status:"populateContact", contact: contacts[0] });
            }
            
            let notificationBody = this.Atheneum.Translation.get('notificationContactFilterModalMatch', 'Contact loaded from filters');
            if(this.options.showCustomNotifications)
                this.Atheneum.UI.Notifications.showCustomNotification("info", notificationBody);
           
            if(this.$modal){
                this.$modal.find('#contactFilterOptions').empty();

                //CHANGED FOR GLU
                if(this.options.iframe){
                    $(this.$modal).modal('hide');
                } else {
                    this.$modal.modal('hide');
                }
               
                $('body').removeClass('modal-open');
                $('.modal-backdrop').remove();    
            }

            if(typeof this.callback === 'function'){
                this.callback({ status:"emptyFilterOptions"});
            }

            return;
        }

        let property = this.Atheneum.Theme.getStringProperty('contactFilteringFirstStep', 'country');

        if(step == 1){
            property = this.Atheneum.Theme.getStringProperty('contactFilteringSecondStep', 'city');
        }else if(step >= 2){
            property = this.Atheneum.Theme.getStringProperty('contactFilteringLastStep', 'email');
            if(step == 3 && property != 'email')
                property = 'email';
            else if(step == 3)
                step = 4;
        }
        
        if(this.$modal && !this.Atheneum.Theme.getBooleanProperty('hideRestartButton', true))
            this.$modal.find('#restartButton').show();

        if(step >= 2 && this.Atheneum.Theme.getBooleanProperty('useGSKContacts', false)){
            if(this.$modal)
                this.$modal.find('#restartButton').hide();
            let promises = [];

            this.apiCallInProgress = false;

            for (let i = 0; i < contacts.length; i++) {
                promises.push(this.getGSKContactInformation(contacts[i].info.mdmId));
            }

            let glThis = this;

            Promise.all(promises).then(function(jsonArr) {
                for(let i = 0; i < jsonArr.length; i++)
                {
                    let json = jsonArr[i];
                  

                    if(json.hasOwnProperty('account')){
                           
                        let contactIndex = contacts.findIndex(x=> x.info.mdmId === json.account.mdmId);
                        if(contactIndex < 0)
                            continue;
                        let contact = contacts[contactIndex];

                        for (let key in json.account) {
                            if (json.account.hasOwnProperty(key) && typeof json.account[key] !== 'undefined') {
                                let keyTranslation = glThis.Atheneum.Theme.getStringProperty('gskKeyTranslation_'+key, key);
                                contact.info[keyTranslation] = json.account[key];
                            }
                        }

                        contacts[contactIndex] = contact;
                    }

                   
                }

                if(glThis.$modal && !glThis.Atheneum.Theme.getBooleanProperty('hideRestartButton', true))
                    glThis.$modal.find('#restartButton').show();

                if(typeof glThis.callback === 'function'){
                    glThis.callback({ status:"setupFilterProperty", property: property, contacts: contacts, step: step});
                }

                glThis.apiCallInProgress = false;
                glThis.setupContactFilterModalForContactsProperty(property, step, contacts);
                
                
            }, function(err) {
                glThis.apiCallInProgress = false;
                if(typeof glThis.callback === 'function'){
                    glThis.callback({ status:"setupFilterProperty", property: property, contacts: contacts, step: step});
                }

                // error occurred
                glThis.setupContactFilterModalForContactsProperty(property, step, contacts);
               
            });
            return;
        }

        if(step >= 2 && this.Atheneum.Theme.getBooleanProperty('useVeevaContacts', false)){
            if(this.$modal)
                this.$modal.find('#restartButton').hide();
            let promises = [];
            this.apiCallInProgress = true;
            for (let i = 0; i < contacts.length; i++) {
                promises.push(this.getVeevaContactInformation(contacts[i].info.crmId));
            }

            let glThis = this;

            Promise.all(promises).then(function(jsonArr) {
                for(let i = 0; i < jsonArr.length; i++)
                {
                    let json = jsonArr[i];
                  

                    if(json.hasOwnProperty('account')){
                           
                        let contactIndex = contacts.findIndex(x=> x.info.crmId === json.account.crmId);
                        if(contactIndex < 0)
                            continue;
                        let contact = contacts[contactIndex];

                        for (let key in json.account) {
                            if (json.account.hasOwnProperty(key) && typeof json.account[key] !== 'undefined') {
                                let keyTranslation = glThis.Atheneum.Theme.getStringProperty('veevaKeyTranslation_'+key, key);
                                contact.info[keyTranslation] = json.account[key];
                            }
                        }

                        contacts[contactIndex] = contact;
                    }

                   
                }

                if(glThis.$modal && !glThis.Atheneum.Theme.getBooleanProperty('hideRestartButton', true))
                    glThis.$modal.find('#restartButton').show();

                if(typeof glThis.callback === 'function'){
                    glThis.callback({ status:"setupFilterProperty", property: property, contacts: contacts, step: step});
                }
                glThis.apiCallInProgress = false;
                glThis.setupContactFilterModalForContactsProperty(property, step, contacts);
                
            }, function(err) {
                glThis.apiCallInProgress = false;
                if(typeof glThis.callback === 'function'){
                    glThis.callback({ status:"setupFilterProperty", property: property, contacts: contacts, step: step});
                }

                // error occurred
                glThis.setupContactFilterModalForContactsProperty(property, step, contacts);
               
            });
            return;
        }


        if(typeof this.callback === 'function'){
            this.callback({ status:"setupFilterProperty", property: property, contacts: contacts, step: step});
        }
        
        this.setupContactFilterModalForContactsProperty(property, step, contacts);
       
    }

    setupContactFilterModalForContactsIndex(index, step, forceInDoubt = false){
        let contact = this.currentFilteredContactFilters[index];

        if(typeof this.callback === 'function'){
            this.callback({ status:"setupForContacts", contacts: contact, step: step, title: '', message: ''});
        }

        this.setupContactFilterModalForContacts([contact], step, forceInDoubt);
    }

    setupContactFilterModalForContactsProperty(property, step, contacts, matchInDoubt = false){
        if(this.$modal){
            this.$modal.find('#contactFilterOptions').empty();
        }
        if(typeof this.callback === 'function'){
            this.callback({ status:"emptyFilterOptions"});
        }
        
        try{
            let i;
            
            this.currentFilteredContactFilters = contacts;

            let propertyMap = [...new Set(contacts.map(x=> x.info[property]))];

            if(propertyMap.length == 0)
            {
                if(step >= 2){
                    this.currentFilteredContactFilters = null;
                    let notificationBody = this.Atheneum.Translation.get('notificationContactFilterError', 'Something has gone wrong and could not load the filters.');
                    if(this.options.showCustomNotifications)
                        this.Atheneum.UI.Notifications.showCustomNotification("info", notificationBody);

                    if(this.$modal){
                        this.$modal.find('#contactFilterOptions').empty();
                        this.$modal.modal('hide');
                        $('body').removeClass('modal-open');
                        $('.modal-backdrop').remove();
                    }

                    if(typeof this.callback === 'function'){
                        this.callback({ status:"emptyFilterOptions"});
                    }

                    return;
                }

                if(typeof this.callback === 'function'){
                    this.callback({ status:"setupForContacts", contacts: contact, step: step, title: '', message: ''});
                }

                this.setupContactFilterModalForContacts(contacts, (step + 1));
                
                return;
            }else if(matchInDoubt || step >= 4){
                
                let fieldsToIgnoreForLastResort = this.Atheneum.Theme.getStringProperty('ignoreFieldsLastResort', '');
                fieldsToIgnoreForLastResort = fieldsToIgnoreForLastResort.split(',');
                for(i=0; i < this.currentFilteredContactFilters.length; i++){
                    let contact = this.currentFilteredContactFilters[i];
                    let contactText = [];

                    for(let j=0; j<form.fields.length; j++){
                        let formField = form.fields[j];
                        if(!contact.info.hasOwnProperty(formField.name))
                          continue;

                        if(contact.info[formField.name] === '')
                            continue;

                        if(formField.type === 'LABEL')
                            continue;

                        if(fieldsToIgnoreForLastResort.indexOf(formField.name) >= 0)
                            continue;

                        let entry = contact.info[formField.name];
                        let entryLabel = entry;
                         let fieldLabel = getTranslatedLabel(formField) || entry;

                        if(formField.type === 'SELECT'){
                            let options = formField.options;
                            let option = options.find(x=> x.value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase() === entry.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase());
                            if(option){
                                entryLabel = option.label;
                            }
                            
                        }else if(formField.type === 'COUNTRY' && typeof countries !== 'undefined'){
                                let useNativeNames = atheneumInstance.Theme.getBooleanProperty('useNativeCountryNames', true);
                                entry = entry.toUpperCase();
                                if (countries.hasOwnProperty(entry)) {
                                    let country = countries[entry];
                                    let countryName = (useNativeNames) ? country.native : country.name;
    
                                    if (countryName) {
                                        entryLabel = countryName;
                                    }
                                }
                        }else if((formField.type === 'LANGUAGE' || formField.name == 'language') && typeof languages !== 'undefined'){
                            let useNativeNames = atheneumInstance.Theme.getBooleanProperty('useNativeLanguageNames', true);
                              
                            let language = languages.find(x=> x.code === entry.toLowerCase());
                            if(typeof language === 'undefined')
                                language = languages.find(x=> x.code === entry.toLowerCase().slice(0, 2));
                            
                            if(typeof language !== 'undefined'){
                                entryLabel = useNativeNames? language.nativeName : language.name;
                            }

                        }

                        contactText += "<p style='font-weight:lighter'><b>"+fieldLabel + "</b>: "+entryLabel+"</p>";
                        
                    }

                    if(this.$modal){
                        let windowText = "window[";
                        if(this.options.iframe)
                            windowText = "parent.window["
                        if(matchInDoubt){
                            this.$modal.find('#contactFilterOptions').append('<label style="width:100%;">'+this.Atheneum.Translation.get('noExactMatchFound', 'No exact match found please review the suggestion or fill in detail manually')+'</label>');
                           this.$modal.find('#contactFilterOptions').append('<div class="contactFilterOption lastResort" onclick="'+windowText+'\'' + this.uid + '\'].setupContactFilterModalForContactsIndex('+i+','+step+', true)">'+contactText+'</div>');
                        }else
                           this.$modal.find('#contactFilterOptions').append('<div class="contactFilterOption lastResort" onclick="'+windowText+'\'' + this.uid + '\'].setupContactFilterModalForContactsIndex('+i+','+step+')">'+contactText+'</div>');
           
                    }else if(typeof this.callback === 'function'){
                        this.callback({ status:"addFilterContactOption", contact: contact, step: step, matchInDoubt: matchInDoubt, index: i, contactText: contactText});
                    }

                }
               return;
            }

            propertyMap.sort();
           
            for(i=0; i<propertyMap.length; i++){
                let entry = propertyMap[i];
                let und = 'false';
                if(entry == undefined){
                    entry = this.Atheneum.Translation.get('contactFilterNoInfo', 'Unknown');
                    und = 'true';
                }

                let entryLabel = entry;

                if(form && form.fields.find(x=> x.name === property)?.type === 'SELECT'){
                        let options = form.fields.find(x=> x.name === property).options;
                        let option = options.find(x=> x.value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase() === entry.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase());
                        if(option){
                            entryLabel = option.label;
                        }
                        
                }else if(property === 'country' && typeof countries !== 'undefined'){
                        let useNativeNames = atheneumInstance.Theme.getBooleanProperty('useNativeCountryNames', true);
                        if (countries.hasOwnProperty(entry)) {
                            let country = countries[entry];
                            let countryName = (useNativeNames) ? country.native : country.name;

                            if (countryName) {
                                entryLabel = countryName;
                            }
                        }
                }

                let windowText = "window[";
                if(this.options.iframe)
                    windowText = "parent.window["

                if(this.$modal)
                    this.$modal.find('#contactFilterOptions').append('<div class="contactFilterOption" onclick="'+windowText+'\'' + this.uid + '\'].filterContactModalFilter(\''+property+'\', \''+escape(entry)+'\', '+step+', '+und+')"><span>'+entryLabel+'</span></div>')
                else if(typeof this.callback === 'function'){
                    this.callback({ status:"addFilterOption", step: step, unknown: und, entry: entry, entryLabel: entryLabel, property: property});
                }
            }
        }catch(err){
            console.log(err);   
            this.setupContactFilterModalForContacts(contacts, (step + 1));
        }

        //CHANGED FOR GLU - MOVED THIS BLOCK OF CODE TO INSIDE THE IF
        // let end = window.performance.now();
        // let dur = end - start;
        // if(this.options.trackTiming && typeof trackTiming === 'function')
        //     trackTiming(this.Atheneum.Translation.get('externalAPITimerTracking', 'externalAPITimerTracking'), dur);

        if((this.Atheneum.Theme.getBooleanProperty('useGSKContacts', false) || this.Atheneum.Theme.getBooleanProperty('useVeevaContacts', false)) && this.Atheneum.Theme.getBooleanProperty('showExternalAPITime', true)){

            let end = window.performance.now();
            let dur = end - start;
            if(this.options.trackTiming && typeof trackTiming === 'function')
                trackTiming(this.Atheneum.Translation.get('externalAPITimerTracking', 'externalAPITimerTracking'), dur);
            dur = dur / 1000;
            dur = (Math.round(dur * 100) / 100).toFixed(2);
            $('#externalAPITimer').html('<p style="text-align:right">'+dur+'s</p>');
            $('#externalAPITimer').show();

            let notificationBody = this.Atheneum.Translation.getFormatted('externalAPITimedBody', 'Took {0}s to retrieve contact data', [(""+dur)]);
            let title = this.Atheneum.Translation.get('externalAPITimedTitle', 'Ready');
            if(this.options.showCustomNotifications)
                this.Atheneum.UI.Notifications.showCustomNotification("info", notificationBody, title);
        }
    }

    filtersStartOver(){
        this.currentFilteredContactFilters = this.currentContactFilters;
       
        let step = 0;
        if(this.currentFilteredContactFilters.length > 5 && this.currentFilteredContactFilters.length < 10)
            step = 1;
        else if(this.currentFilteredContactFilters.length <= 5)
            step = 2;
        this.setupContactFilterModalForContacts(this.currentFilteredContactFilters, step);
    }
}

function anySimilarEmails(emails, contactEmail) {
    if(typeof contactEmail === 'undefined')
        return false;
    
    if(emails.length == 0)
        return false;

        
    let i;
    let minimumSimilarity = SalesToolkit.Theme.getFloatProperty('minimumSimilarity', 1);

    for (i = 0; i < emails.length; i++) {
        let email = emails[i].address;
        if (similarity(email, contactEmail) >= minimumSimilarity)
            return true;
    }

    return false;
}

function anyMatchingPhones(phones, contactPhone){
    if(typeof contactPhone === 'undefined')
        return false;
    
    if(phones.length == 0)
        return false;

    let i;

    contactPhone = contactPhone.replace(/[^\d]/g, '');

    for (i = 0; i < phones.length; i++) {
        let phone = phones[i].number;
        phone = phone.replace(/[^\d]/g,'');
        if (phone == contactPhone)
            return true;
    }

    return false;
}

function similarity(s1, s2) {
    if(typeof s1 !== 'string')
        return false;
    if(typeof s2 !== 'string')
        return false;

    var longer = s1;
    var shorter = s2;
    if (s1.length < s2.length) {
        longer = s2;
        shorter = s1;
    }
    var longerLength = longer.length;
    if (longerLength == 0) {
        return 1.0;
    }
    return (longerLength - editDistance(longer, shorter)) / parseFloat(longerLength);
}

function editDistance(s1, s2) {
    s1 = s1.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
    s2 = s2.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

    var costs = new Array();
    for (var i = 0; i <= s1.length; i++) {
        var lastValue = i;
        for (var j = 0; j <= s2.length; j++) {
            if (i == 0)
                costs[j] = j;
            else {
                if (j > 0) {
                    var newValue = costs[j - 1];
                    if (s1.charAt(i - 1) != s2.charAt(j - 1))
                        newValue = Math.min(Math.min(newValue, lastValue),
                            costs[j]) + 1;
                    costs[j - 1] = lastValue;
                    lastValue = newValue;
                }
            }
        }
        if (i > 0)
            costs[s2.length] = lastValue;
    }
    return costs[s2.length];
}